module.exports = __webpack_public_path__ + "0e5db11f113d00ba90b6a5bda7735b68.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/6_column_large_x1/public/games/coh_image_2.png
// module id = 473
// module chunks = 0